import React, { useState } from "react";
import HomeIcon from '@mui/icons-material/Home';
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import { useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import axios from "axios";
import { BACKEND_BASE_URL, LOGOUT_ENDPOINT } from "../../constants/Constants";
import AccountBoxIcon from '@mui/icons-material/AccountBox';

const Navbar = ({ setIsSidebarOpen }) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { activeShopHash, authUser, logout } = useAuth();


  const navMenu = [
    // {
    //   title: "My Profile",
    //   path: "/dashboard",
    //   icon: <Dashboard />,
    // },

    {
      title: "Logout",
      path: "/",
      icon: <img src="/" />,
      onClick: () => {
        let logUrl = BACKEND_BASE_URL + LOGOUT_ENDPOINT;
        let data = {
          payLoad: {
            apiToken: authUser.apiToken,
            shopHash: activeShopHash.id,
          },
        };
        axios
          .post(logUrl, data)
          .then((response) => {
            logout();
            navigate("/login");
            //window.location.href = window.location.origin;
          })
          .catch((error) => {
            logout();
            navigate("/login");
            //window.location.href = window.location.origin;
            console.log("Error : ", error);
            //window.location.href = "#/error";
          });
      },
    },
    // {
    //   title: "Change Password",
    //   path: "/",
    //   icon: <PublishedWithChangesSharpIcon />,
    //   onClick: () => {
    //     window.location.href = window.location.origin + "/reset-password";

    //   }
    // }
  ];



  return (
    <div className="navbar" style={{ backgroundColor: "rgba(0, 118, 118, 1)" }}>
      <div className="navbar-wrapper">
        <div></div>
        <div className="navbarItems">
          <div className="navbarItem">
            {/* <ChatBubbleOutlineOutlinedIcon className="nav-icon" />
            <div className="nav-icon-counter">2</div> */}
          </div>

          <div className="navbarItem">
            <HomeIcon
              className="nav-img"
              onClick={() => navigate("/home")}

              sx={{ flexGrow: 1, color: "white", display: { xs: 'flex', md: 'flex', sm: 'flex' } }} />
            {/* <img
              onClick={() => setOpen(!open)}
              src={HOTEL_IMAGE}
              alt="HOTEL_IMAGE_VIEW"
              style={{ width: "20 px", height: "20 px" }}
              className="nav-img"
            /> */}
            <AccountBoxIcon
              className="nav-img"
              sx={{ color: "white" }}
              onClick={() => setOpen(!open)} />

            {open && (
              <div className="navImg">
                <ul className="nav-dropdown">
                  {navMenu.map((item) => {
                    return (
                      <li key={item}>
                        <p className="navLinkS" onClick={item.onClick}>
                          {item.title}
                        </p>
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}
          </div>
          <div className="navbarItem mobileOnly">
            <MenuOutlinedIcon
              className="menu-icon"
              sx={{ color: "white" }}
              onClick={() => {
                // toggle();
                setIsSidebarOpen(true);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
